var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54708C",
    d: "M20 1c1.105 0 2 .895 2 2v18c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h16zm-1 18H5c-.552 0-1 .448-1 1s.448 1 1 1h14c.552 0 1-.448 1-1s-.448-1-1-1zM12 3c-.552 0-1 .448-1 1v10.585L8.463 12.05c-.39-.39-1.023-.39-1.414 0-.39.39-.39 1.024 0 1.414l4.243 4.243.087.078c.393.31.964.285 1.327-.078l4.243-4.243c.39-.39.39-1.023 0-1.414-.39-.39-1.024-.39-1.414 0l-2.537 2.535L13 4c0-.552-.448-1-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoff);
export default __webpack_public_path__ + "static/media/dropoff.e6ae7f5b24aa1780ad93723b86b5925b.svg";
export { ForwardRef as ReactComponent };